import React from 'react';
import AnniversaryDatePicker from '../../DatePicker/DatePickerAnniversary';
import { getTranslationKey } from '../../../modules/utils';
import { IShopSalesAutomation } from '../../../modules/types';
import { languagesMap } from '../../../pages/collectionEdit/settingsTabContent/SettingsSection';
import { InlineForm, SmallInputWrapper } from './styles';

interface IProps {
  anniversaryCouponCodeAdvertising: IShopSalesAutomation['anniversaryCouponCodeAdvertising'];
  updateAnniversaryDate: (dateStr: string) => void;
}

export const AnniversaryDatePickerSection = React.memo(
  ({ anniversaryCouponCodeAdvertising, updateAnniversaryDate }: IProps) => (
    <InlineForm offsetLeft>
      <SmallInputWrapper>
        <AnniversaryDatePicker
          id="anniversaryDatePicker"
          date={anniversaryCouponCodeAdvertising?.anniversaryDate ?? ''}
          defaultDate={anniversaryCouponCodeAdvertising?.anniversaryDate ?? ''}
          callback={updateAnniversaryDate}
          placeholder={getTranslationKey('collectionShop.anniversaryDateLabel')}
          label={getTranslationKey('collectionShop.anniversaryDateLabel')}
          minDate={new Date(1900, 0, 1)}
          maxDate={new Date(2100, 11, 31)}
          format={languagesMap[window.LANGUAGE_SW] === 'de' ? 'DD.MM' : 'DD/MM'}
        />
      </SmallInputWrapper>
    </InlineForm>
  )
);
